import React from "react";
import obj from "../utils/constants";
import { Button, Col, Form, Row } from "react-bootstrap";
const FilterMenu = ({
  filter,
  setFilter,
  handleSearch,
  getData,
  showType,
  betStatus,
  Last,
  timePeriod,
  timePeriod2,
  showReset,
}) => {
  return (
    <div>
      {showType && (
        <div className="d-lg-flex">
          <div key={`inline-radio`} className="mb-1">
            <ul className="list-unstyled mb-0 d-flex">
              {obj.betCheckData.map((type) => {
                return (
                  <li>
                    <Form.Check
                      inline
                      label={type.value}
                      name={type.label}
                      type="radio"
                      checked={type.label === filter.type ? true : false}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          type: e.target.name,
                          betType:
                            type?.value == "Casino" ? "casino" : "betfair",
                        })
                      }
                      id={`inline-radio-1`}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
          {filter.type != 3 && (
            <div key={`inline-radio`} className="mb-2">
              <ul className="list-unstyled mb-0 d-flex">
                {obj.betCheckDataInner.map((type) => {
                  return (
                    <li>
                      <Form.Check
                        inline
                        label={type.value}
                        name={type.label}
                        type="radio"
                        checked={type.label === filter.betType ? true : false}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            betType: e.target.name,
                          })
                        }
                        id={`inline-radio-1`}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      )}

      <div className="bet_status mb-0">
        <div style={{ display: "flex", alignItems: "center" }}>
          {betStatus && (
            <div className="bet-sec" style={{ marginRight: "10px" }}>
              <Form.Label className="mt-2 me-2">Bet Status</Form.Label>
              <Form.Select
                className="small_select"
                onChange={(e) =>
                  setFilter({ ...filter, status: e.target.value })
                }
                value={filter.status}
                aria-label="Default select example"
              >
                {filter.betType == "betfair" &&
                  (filter.type == 4 ||
                    filter.type == 2 ||
                    filter.type == 1) && (
                    <>
                      {" "}
                      <option value="unmatched">Unmatched</option>
                      <option value="matched">Matched</option>
                    </>
                  )}

                <option value="completed">Settled</option>
                <option value="suspend">Cancelled</option>
                <option value="voided">Voided</option>
              </Form.Select>
            </div>
          )}
          {Last && (
            <div className="bet-sec" style={{ marginRight: "10px" }}>
              <Form.Label className="mt-2 me-2">Last</Form.Label>
              <Form.Select
                className="small_select"
                onChange={(e) =>
                  setFilter({ ...filter, limit: e.target.value })
                }
                value={filter.limit}
                aria-label="Default select example"
              >
                <option value={100}>100 Txn</option>
                <option value={200}>200 Txn</option>
                <option value={500}>500 Txn</option>
                <option value={1000}>1000 Txn</option>
                <option value={5000}>5000 Txn</option>
                <option value={10000}>10000 Txn</option>
                <option value={""}>All</option>
              </Form.Select>
            </div>
          )}

          {timePeriod && (
            <>
              <div
                className="bet-sec bet-period"
                style={{ marginRight: "10px" }}
              >
                <Form.Label className="mt-2 me-2">From</Form.Label>
                <Form.Group className="form-group">
                  <Form.Control
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        fromPeriod: e.target.value,
                        filterByDay: "",
                      })
                    }
                    max={new Date().toISOString().split("T")[0]}
                    value={filter.fromPeriod}
                    type="date"
                  />
                  <Form.Control
                    style={{ width: "60px" }}
                    className="small_form_control"
                    type="text"
                    placeholder="00:00"
                    disabled
                  />
                </Form.Group>
              </div>

              <div className="bet-sec bet-period">
                <Form.Label className="mt-2 me-2">To</Form.Label>
                <Form.Group className="form-group">
                  <Form.Control
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        toPeriod: e.target.value,
                        filterByDay: "",
                      })
                    }
                    min={
                      filter?.fromPeriod
                        ? new Date(filter?.fromPeriod)
                            .toISOString()
                            .split("T")[0]
                        : new Date()
                    }
                    disabled={filter.fromPeriod ? false : true}
                    max={new Date().toISOString().split("T")[0]}
                    value={filter.toPeriod}
                    type="date"
                  />
                  <Form.Control
                    style={{ width: "60px" }}
                    className="small_form_control"
                    type="text"
                    placeholder="23:59"
                    disabled
                  />
                </Form.Group>
              </div>
            </>
          )}
        </div>

        <div className="history-btn mt-2">
          <ul className="list-unstyled mb-0">
            {timePeriod2 && (
              <>
                <li>
                  <Button
                    className={"me-0 theme_light_btn"}
                    onClick={(e) =>
                      setFilter({
                        ...filter,
                        filterByDay: "today",
                      })
                    }
                  >
                    Just For Today
                  </Button>
                </li>
                <li>
                  <Button
                    className={"me-0 theme_light_btn"}
                    onClick={(e) =>
                      setFilter({
                        ...filter,
                        filterByDay: "yesterday",
                      })
                    }
                  >
                    From Yesterday
                  </Button>
                </li>{" "}
              </>
            )}
            <li>
              <Button
                style={{ marginRight: "0" }}
                className="theme_light_btn theme_dark_btn"
                onClick={() => handleSearch("search")}
              >
                Search
              </Button>
            </li>
            {showReset && (
              <li>
                <Button
                  className="theme_light_btn"
                  onClick={() => {
                    setFilter({
                      type: "4",
                      betType: "betfair",
                      status: "completed",
                      fromPeriod: new Date(),
                      toPeriod: new Date(),

                      page: 1,
                      limit: 100,
                    });
                    getData({
                      type: "4",
                      betType: "betfair",
                      status: "completed",
                      fromPeriod: new Date(),
                      toPeriod: new Date(),
                      page: 1,
                      limit: 100,
                    });
                  }}
                >
                  Reset
                </Button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FilterMenu;
